<div class="p-24">
  <h3 class="mat-h3">Reference display mode</h3>
  <p class="mat-body-1">
    Choose how references are shown in chat and conversation results.
  </p>
  <ul class="mat-body-2 hint-list">
    <li><strong>Reference to source file only</strong> — show only the source document.</li>
    <li><strong>Source file and ref in ref</strong> — show both the source document and the nested reference.</li>
    <li><strong>Reference in reference only</strong> — show only the nested reference when available.</li>
  </ul>

  <mat-form-field class="w-full" appearance="outline">
    <mat-label>Display</mat-label>
    <mat-select
      id="reference-citation-display-select"
      [(ngModel)]="value"
      aria-label="Reference citation display mode"
    >
      <mat-option value="source_only">Reference to source file only</mat-option>
      <mat-option value="all">Source file and ref in ref</mat-option>
      <mat-option value="ref_in_ref_only">Reference in reference only</mat-option>
    </mat-select>
  </mat-form-field>

  <div class="d-flex justify-content-end m-t-16">
    <button mat-raised-button color="accent" type="button" (click)="save()">Save</button>
  </div>
</div>
